import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

// paginas
import Contato from './pages/contato'
import Home from './pages/home'
import Portfolio from './pages/portfolio'
import Somos from './pages/quem_somos'
import Servicos from './pages/servicos'
// import ErroPage from './pages/erro'

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

import Cookie from 'js-cookie'

require('react-web-vector-icons/fonts');

let userLang = navigator.language || navigator.userLanguage; 

let language = Cookie.get('language') ? Cookie.get('language') : (userLang === "pt-BR" ? 'br' : 'us')

function handleLanguage(lang) {
    if(lang !== Cookie.get('language')) {
      Cookie.set('language', lang)
      this.language = Cookie.get('language')
      window.location.reload()
    }
}

ReactDOM.render(
    <Router onUpdate={() => window.scrollTo(0, 0)}>
       <Switch>
            <Route path="/" exact={true} component={ (props) => <Home language={ language }
             handleLanguage={ handleLanguage } /> } />
            <Route path="/contato" component={ (props) => <Contato language={ language }
             handleLanguage={ handleLanguage } /> } />
             <Route path="/contact-us" component={ (props) => <Contato language={ language }
              handleLanguage={ handleLanguage } /> } />
            <Route path="/portfolio" component={ (props) => <Portfolio language={ language }
             handleLanguage={ handleLanguage } /> } />
             <Route path="/portfolio" component={ (props) => <Portfolio language={ language }
              handleLanguage={ handleLanguage } /> } />
            <Route path="/servicos" component={ (props) => <Servicos language={ language }
             handleLanguage={ handleLanguage } /> } />
             <Route path="/services" component={ (props) => <Servicos language={ language }
              handleLanguage={ handleLanguage } /> } />
            <Route path="/quem-somos" component={ (props) => <Somos language={ language }
             handleLanguage={ handleLanguage } /> } />
             <Route path="/about-us" component={ (props) => <Somos language={ language }
             handleLanguage={ handleLanguage } /> } />
            {/* <Route path="/painel" component={ (props) => <Painel language={ language }
         />} />  */}   
            {/* <Route path="*" component={ (props) => <ErroPage language={ language }
             handleLanguage={ handleLanguage } /> } /> */}
        </Switch>
    </Router>
    
, document.getElementById('root'));
